import type { PropsWithChildren } from "react";
import ButtonTemplate, { type ButtonTemplateProps } from "@/Components/Form/Buttons/ButtonTemplate";

export default function PrimaryButton({ children, ...rest }: PropsWithChildren<ButtonTemplateProps>) {
    return <ButtonTemplate {...rest}>{children}</ButtonTemplate>;
}
